import { call, put, takeLatest } from "@redux-saga/core/effects";
import InvoiceService from "../../Services/RestApiManager/InvoiceManager/InvoiceRequestService";
import { errorInvoiceList, errorInvoicePaymentDate, errorInvoicesInfoById, errorReGenerateInvoicePDF, errorUpdateInvoice, INVOICE_ACTION, responseInvoiceList, responseInvoicePaymentDate, responseInvoicesInfoById, responseReGenerateInvoicePDF, responseUpdateInvoice } from "./InvoiceActionCreator";
import { downloadBase64AsFile, downloadBufferToExcel } from "../../helpers/Localstorage";

export function* invoiceListRequest(action) {
  try {
    const response = yield call(
      InvoiceService.shared.invoicesListRequest,
      action.data
    );
    yield put(responseInvoiceList(response));
  } catch (error) {
    yield put(errorInvoiceList(error));
  } 
}
export function* updateInvoiceRequest(action) {
  try {
    const response = yield call(
      InvoiceService.shared.updateInvoiceRequest,
      action.data,
      action.id
    );
    yield put(responseUpdateInvoice(response));
  } catch (error) {
    yield put(errorUpdateInvoice(error));
  }
}

export function* reGenerateInvoicePDFRequest(action) {
  try {
    const response = yield call(
      InvoiceService.shared.reGenerateInvoicePDFRequest,
      action.data
    );
    // if (response) {
    //   downloadBase64AsFile(response.base64Url, response.fileName, "application/pdf")
      yield put(responseReGenerateInvoicePDF(response));
    // }
  } catch (error) {
    yield put(errorReGenerateInvoicePDF(error));
  }
}

export function* invoicePaymentDateRequest(action) {
  try {
    const response = yield call(
      InvoiceService.shared.invoicePaymentDateRequest,
      action.data,
      action.id
    );
    yield put(responseInvoicePaymentDate(response));
  } catch (error) {
    yield put(errorInvoicePaymentDate(error));
  }
}


export function* invoiceInfoByIdRequest(action) {try {
    const response = yield call(
      InvoiceService.shared.invoiceInfoById,
      action.data
    );
    yield put(responseInvoicesInfoById(response));
  } catch (error) {
    yield put(errorInvoicesInfoById(error));
  }
}

export function* invoiceWatcherSaga() {
  yield takeLatest(INVOICE_ACTION.REQUEST_INVOICE_LIST,invoiceListRequest);
  yield takeLatest(INVOICE_ACTION.REQUEST_UPDATE_INVOICE,updateInvoiceRequest);
  yield takeLatest(INVOICE_ACTION.REQUEST_REGENERATE_INVOICE,reGenerateInvoicePDFRequest);
  yield takeLatest(INVOICE_ACTION.REQUEST_INVOICE_PAYMENT_DATE,invoicePaymentDateRequest);
  yield takeLatest(INVOICE_ACTION.REQUEST_INVOICE_INFO_BY_ID,invoiceInfoByIdRequest)
}